import { render } from "./App.vue?vue&type=template&id=342c3fde"
const script = {}

import "./App.vue?vue&type=style&index=0&id=342c3fde&lang=css"
script.render = render

export default script